import { Box, makeStyles } from '@material-ui/core';
import React from 'react';
import { Link } from 'react-router-dom';
import { CONFIRM_ADMISSIONS_VIEW_DETAILS_ROUTE } from '../../../routes/routes';
import { useDispatch } from 'react-redux';
import { leadDetailsData } from './ConfirmAdmissionStore/ConfirmAdmissionSlice';
import { IconButton, Menu, MenuItem } from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';

const useStyle = makeStyles((theme) => ({
  textStyle: {
    textDecoration: 'underline',
    color: theme.palette.buzzBlackTextColor,
  },
}));

export const confirmAdmissionColumn2 = [
  { Header: 'User Id', accessor: 'leadId' },
  { Header: 'User Name', accessor: 'leadName' },
  {
    Header: 'Email',
    accessor: 'emailid',
  },
  { Header: 'Phone No.', accessor: 'phone' },
  {
    Header: 'Action',
    accessor: '',
    Cell: () => {
      const [anchorEl, setAnchorEl] = React.useState(null);
      const open = Boolean(anchorEl);

      const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
      };

      const handleClose = () => {
        setAnchorEl(null);
      };
      const options = ['Active', 'Deactive', 'Delete'];
      const ITEM_HEIGHT = 48;
      return (
        <>
          <Box display="flex">
            <Box
              width={80}
              // onClick={setDetails}
              // component={Link}
              // to={`${CONFIRM_ADMISSIONS_VIEW_DETAILS_ROUTE}?leadId=${leadId}&schoolId=${schoolId}&formId=${formId}`}
              fontSize={14}
              // className={classes.textStyle}
              // style={{ cursor: 'not-allowed' }}
            >
              {/* View */}
              <IconButton
                aria-label="more"
                aria-controls="long-menu"
                aria-haspopup="true"
                onClick={handleClick}>
                <MoreVertIcon />
              </IconButton>
              <Menu
                id="long-menu"
                anchorEl={anchorEl}
                keepMounted
                open={open}
                onClose={handleClose}
                PaperProps={{
                  style: {
                    maxHeight: ITEM_HEIGHT * 4.5,
                    width: '20ch',
                  },
                }}>
                {options.map((option) => (
                  <MenuItem
                    key={option}
                    selected={option === 'Pyxis'}
                    onClick={handleClose}>
                    {option}
                  </MenuItem>
                ))}
              </Menu>
            </Box>
          </Box>
        </>
      );
    },
  },
];

export const confirmAdmissionColumn1 = [
  { Header: 'Branch', accessor: 'leadId' },
  // { Header: 'Parent Id', accessor: 'parentid' },
  {
    Header: 'Parent Name',
    accessor: 'userName',
  },
  { Header: 'Review', accessor: 'review' },
  { Header: 'Rating', accessor: 'rating' },
  {
    Header: 'Action',
    accessor: '',
    Cell: () => {
      const [anchorEl, setAnchorEl] = React.useState(null);
      const open = Boolean(anchorEl);

      const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
      };

      const handleClose = () => {
        setAnchorEl(null);
      };
      const options = ['View', 'Approve', 'Reject'];
      const ITEM_HEIGHT = 48;
      return (
        <>
          <Box display="flex">
            <Box
              width={80}
              // onClick={setDetails}
              // component={Link}
              // to={`${CONFIRM_ADMISSIONS_VIEW_DETAILS_ROUTE}?leadId=${leadId}&schoolId=${schoolId}&formId=${formId}`}
              fontSize={14}
              // className={classes.textStyle}
              // style={{ cursor: 'not-allowed' }}
            >
              {/* View */}
              <IconButton
                aria-label="more"
                aria-controls="long-menu"
                aria-haspopup="true"
                onClick={handleClick}>
                <MoreVertIcon />
              </IconButton>
              <Menu
                id="long-menu"
                anchorEl={anchorEl}
                keepMounted
                open={open}
                onClose={handleClose}
                PaperProps={{
                  style: {
                    maxHeight: ITEM_HEIGHT * 4.5,
                    width: '20ch',
                  },
                }}>
                {options.map((option) => (
                  <MenuItem
                    key={option}
                    selected={option === 'Pyxis'}
                    onClick={handleClose}>
                    {option}
                  </MenuItem>
                ))}
              </Menu>
            </Box>
          </Box>
        </>
      );
    },
  },
];

export const confirmAdmissionColumn = [
  { Header: 'Branch Id', accessor: 'branchId' },
  { Header: 'School Name', accessor: 'schoolName' },
  {
    Header: 'Date Created',
    accessor: 'createdAt',
  },
  // {
  //   Header: 'Particular',
  //   accessor: 'assignedTo',
  // },
  // { Header: 'Date Of Request', accessor: 'branch' },
  { Header: 'Status', accessor: 'status' },
  {
    Header: 'Action',
    accessor: '',
    Cell: (val) => {
      const dispatch = useDispatch();
      const classes = useStyle();
      const payload = val.cell.row.original;
      //   console.log('payload', payload);
      const setDetails = () => {
        dispatch(leadDetailsData(payload));
      };
      return (
        <>
          <Box display="flex">
            <Box
              onClick={setDetails}
              component={Link}
              to={'/approval-management/view-details-management-app'}
              fontSize={14}
              className={classes.textStyle}>
              View Details
            </Box>
          </Box>
        </>
      );
    },
  },
];
export const confirmAdmissionColumn6 = [
  { Header: 'Branch', accessor: 'leadId' },
  { Header: 'Parent Id', accessor: 'parentid' },
  {
    Header: 'Parent Name',
    accessor: 'leadName',
  },
  // {
  //   Header: 'Particular',
  //   accessor: 'assignedTo',
  // },
  // { Header: 'Date Of Request', accessor: 'branch' },
  { Header: 'Review', accessor: 'status' },
  { Header: 'Rating', accessor: 'rating' },
  {
    Header: 'Action',
    accessor: '',
    Cell: (val) => {
      const dispatch = useDispatch();
      const classes = useStyle();
      const payload = val.cell.row.original;
      //   console.log('payload', payload);
      const setDetails = () => {
        dispatch(leadDetailsData(payload));
      };
      return (
        <>
          <Box display="flex">
            <Box
              onClick={setDetails}
              component={Link}
              to={'/approval-management/view-details-management-app'}
              fontSize={14}
              className={classes.textStyle}>
              View Details
            </Box>
          </Box>
        </>
      );
    },
  },
];
export const confirmAdmissionColumn5 = [
  { Header: 'User Id', accessor: 'leadId' },
  { Header: 'Parent Name', accessor: 'leadName' },
  {
    Header: 'Email',
    accessor: 'emailid',
  },
  // {
  //   Header: 'Particular',
  //   accessor: 'assignedTo',
  // },
  // { Header: 'Date Of Request', accessor: 'branch' },
  { Header: 'Phone No.', accessor: 'phone' },
  {
    Header: 'Action',
    accessor: '',
    Cell: (val) => {
      const dispatch = useDispatch();
      const classes = useStyle();
      const payload = val.cell.row.original;
      //   console.log('payload', payload);
      const setDetails = () => {
        dispatch(leadDetailsData(payload));
      };
      return (
        <>
          <Box display="flex">
            <Box
              onClick={setDetails}
              component={Link}
              to={'/approval-management/view-details-management-app'}
              fontSize={14}
              className={classes.textStyle}>
              View Details
            </Box>
          </Box>
        </>
      );
    },
  },
];
export const pendingTableColumn = [
  {
    Header: 'Application ID',
    accessor: 'formId',
  },
  {
    Header: 'Lead Name',
    accessor: 'leads.name',
  },
  {
    Header: 'Created On',
    accessor: 'leads.createdDate',
    Cell: (val) => {
      const { leads } = val.cell.row.original;
      const { createdDate } = leads;
      let date = createdDate.split('T')[0];
      return (
        <>
          <Box display="flex">{date}</Box>
        </>
      );
    },
  },
  {
    Header: 'Assigned To',
    accessor: 'leads.assignedToName',
  },
  { Header: 'Branch', accessor: 'leads.schoolName' },
  {
    Header: 'Action',
    accessor: '',
    Cell: (val) => {
      const dispatch = useDispatch();
      const classes = useStyle();
      const payload = val.cell.row.original;
      const { leads, formId } = payload;
      const { leadId, schoolId } = leads;
      const setDetails = () => {
        dispatch(leadDetailsData(payload));
      };
      return (
        <>
          <Box display="flex">
            <Box
              width={80}
              onClick={setDetails}
              component={Link}
              to={`${CONFIRM_ADMISSIONS_VIEW_DETAILS_ROUTE}?leadId=${leadId}&schoolId=${schoolId}&formId=${formId}`}
              fontSize={14}
              className={classes.textStyle}>
              View Details
            </Box>
          </Box>
        </>
      );
    },
  },
];

export const archiveTableColumn = [
  {
    Header: 'Application ID',
    accessor: 'formId',
  },
  {
    Header: 'Lead Name',
    accessor: 'leads.name',
  },
  {
    Header: 'Created On',
    accessor: 'leads.createdDate',
    Cell: (val) => {
      const { leads } = val.cell.row.original;
      const { createdDate } = leads;
      let date = createdDate.split('T')[0];
      return (
        <>
          <Box display="flex">{date}</Box>
        </>
      );
    },
  },
  {
    Header: 'Assigned To',
    accessor: 'leads.assignedToName',
  },
  { Header: 'Branch', accessor: 'leads.schoolName' },
];
